import { getTaxonomyTasks } from './caseTaxonomyServices'

export type TaxonomyTask = Awaited<ReturnType<typeof getTaxonomyTasks>>[number]
export type TaxonomyServiceType = TaxonomyTask['serviceTypes'][number]
export type TaxonomyCategory = TaxonomyServiceType['categories'][number]
export type TaxonomySubcategory = TaxonomyCategory['subcategories'][number]
export type TaxonomyNatureOption = TaxonomyServiceType['natures'][number]
export type TaxonomyStatus = TaxonomyTask['statuses'][number]

export interface TaxonomySelection {
  task?: TaxonomyTask
  serviceType?: TaxonomyServiceType
  category?: TaxonomyCategory
  subcategory?: TaxonomySubcategory
  nature?: TaxonomyNatureOption
}

export interface TaxonomyCascadeFormValues {
  taxonomyTask?: TaxonomyTask | null
  taxonomyServiceType?: TaxonomyServiceType | null
  taxonomyCategory?: TaxonomyCategory | null
  taxonomySubcategory?: TaxonomySubcategory | null
  taxonomyNature?: TaxonomyNatureOption | null
}

export const TAXONOMY_FIELD_NAMES: (keyof TaxonomyCascadeFormValues)[] = [
  'taxonomyTask',
  'taxonomyServiceType',
  'taxonomyCategory',
  'taxonomySubcategory',
  'taxonomyNature',
]
